import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const guess = (u) => {
  const parts = (u.name || "").split(" ").filter(Boolean);
  return { first_name: u.first_name || parts[0] || "", last_name: u.last_name || parts.slice(1).join(" ") };
};

export default function CompleteProfile() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState(() => guess(user));
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const next = useLocation().state?.from || "/";
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/me/profile", form);
      setUser(data);
      navigate(next === "/completa-profilo" ? "/" : next, { replace: true });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };


  return (
    <div className="px-6 py-10" data-testid="complete-profile-page">
      <p className="eyebrow">Un ultimo passaggio</p>
      <h1 className="font-serif text-4xl font-semibold text-[#0D2517]">Completa il profilo</h1>
      <p className="mt-2 text-sm text-[#5b6b60]">Inserisci nome e cognome. Ti verrà chiesto una sola volta.</p>
      <form onSubmit={submit} className="mt-8 space-y-3" data-testid="complete-profile-form">
        <input className="field" placeholder="Nome" autoComplete="given-name" value={form.first_name} onChange={set("first_name")} required data-testid="profile-first-name-input" />
        <input className="field" placeholder="Cognome" autoComplete="family-name" value={form.last_name} onChange={set("last_name")} required data-testid="profile-last-name-input" />
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="complete-profile-submit">
          {busy ? "Attendere…" : "SALVA E CONTINUA"}
        </button>
      </form>
    </div>
  );
}
